// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import {
  getToken,
  setToken,
  setExpiresIn
} from '@/utilsCloud/auth'
import {getQueryObject} from '@/utils/index'
let queryObj =getQueryObject();
if (queryObj.acu) {
  let acu = queryObj.acu.replace('#/','')
  localStorage.setItem('tokenId', acu);
  setToken(acu);
  setExpiresIn(72)
  location.href=location.origin;
}

import './permission' // permission control

// 引入登录组件
import LoginBox from '@/components/LoginBox';
Vue.use(LoginBox);

import YcyPlayer from '@/components/YcyPlayer';

//引用ui组价
import 'wowjs/css/libs/animate.css'
import ElementUI from 'element-ui';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import './assets/fonts/ycy.css'
import './assets/fonts/ycy-b/ycy-b.css'
import 'font-awesome/css/font-awesome.min.css'
import {
  Message
} from 'element-ui';
import './less/main.less';
import './less/element-ui.less';
import 'element-ui/lib/theme-chalk/index.css';
// import '@/assets/theme/index.css';
import $ from 'jquery'
import axios from 'axios';
import VideoPlayer from 'vue-video-player';
import QRCode from 'qrcode'
import Pagination from '@/components/Pagination'
import Distpicker from 'v-distpicker'
import 'swiper/css/swiper.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
import './assets/icon/iconfont.css'
import preventReClick from '@/assets/preventReClick' // 防多次点击，重复提交

import {
  getEnterpriseWebsite,
  getEntpOtherConfig
} from "@/apiCloud/common.js"

Vue.prototype.$axios = axios;
Vue.config.productionTip = false
Vue.component('Pagination', Pagination)
Vue.component('v-distpicker', Distpicker)
Vue.component('YcyPlayer', YcyPlayer)

Vue.use(ElementUI)
Vue.use(ViewUI);
Vue.use(VideoPlayer)
Vue.use(preventReClick)
// Vue.use(router)
let that = this
var tokenId = window.localStorage.getItem("tokenId")

router.afterEach((to, from) => { // 路由跳转之后，直接定位到顶部
  window.scrollTo(0, 0)
  // console.log(to.fullPath, from.fullPath, "2")
  // if (from.fullPath == "/coursePlay") {
  //   history.go(0)
  //   // window.location.replace("/coursePlay")
  // }
  localStorage.setItem('isWatch', "no")
});
router.beforeEach((to, from, next) => { // 路由跳转之前，这里处理页面多开看视频
  let isType = localStorage.getItem("isWatch")
  console.log(to,33)
  // console.log(to.fullPath, from.fullPath, "1")
  if (to.fullPath.includes("/coursePlay")) {
    if (isType == "yes") {
      Message({
        message: '禁止页面多开进行学习',
        type: 'warning',
        duration: 2000,
      })
      console.log("退出")
      router.push({
        path: "/studyCentre",
      })
    } else {
      next()
    }
  } else {
    next()
  }
});
router.beforeEach((to, form, next) => {
  if (to.fullPath == "/home") {
    // 获取企业id和浏览器信息
    let entpWebsite = location.origin;
    // 开发模式定义固定域名
    // const testUrl = to.query.devhost || 'http://jg0011026.e.hbzclm.com/';
    // const testUrl = to.query.devhost || 'http://dlpxxx001.e.hbzclm.com/';
    // const testUrl = to.query.devhost || 'http://wxjg001.e.hbzclm.com/';
    const testUrl = to.query.devhost || 'http://cspx001.e.eceping.net/';
    // const testUrl = to.query.devhost || 'https://cspx.e.hbzclm.com/'; // 测试环境
    if (process.env.NODE_ENV === "development") {
      entpWebsite = testUrl
    }
    let param = {
      entpWebsite: entpWebsite
    }
    getEnterpriseWebsite(param).then(res => {
      if (res.code == 200) {
        localStorage.setItem("enterpriseId", res.data.entpId);
        localStorage.setItem("entpCreditNo", res.data.entpCreditNo);
        let data = {};
        getEntpOtherConfig(data).then((res) => {
          if (res.data.visitorMode == 1) {
            if (!getToken()) {
              router.push({
                path: "/login"
              })
            } else {
              next()
            }
          } else {
            next()
          }
        });
      }
    })
  } else {
    next()
  }
})
// if(sessionStorage.getItem("empName")){
//     document.title = sessionStorage.getItem("empName")
// }

axios.interceptors.request.use(
  config => {
    // Loading.showFullScreenLoading()
    // config.data = JSON.stringify(config.data);
    // config.headers = {
    //     'Content-Type': 'application/json',
    // }
    return config;
  },
  error => {
    // Loading.tryHideFullScreenLoading()
    Message.error({
      message: '服务器异常',
      duration: 1000,
    })
    return Promise.reject(error);
  }
);

Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === '$isUserLogin' || key === 'fullscreenLoading') {

    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);

        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
}

/**
 * 节流函数
 * @param method 事件触发的操作
 * @param mustRunDelay 间隔多少毫秒需要触发一次事件
 */
function throttle(method, mustRunDelay) {
  let timer,
    args = arguments,
    start;
  return function loop() {
    let self = this;
    let now = Date.now();
    if (!start) {
      start = now;
    }
    if (timer) {
      clearTimeout(timer);
    }
    if (now - start >= mustRunDelay) {
      method.apply(self, args);
      start = now;
    } else {
      timer = setTimeout(function () {
        loop.apply(self, args);
      }, 50);
    }
  }
}
window.onscroll = throttle(function () {
  var scrollTop =
    document.documentElement.scrollTop || document.body.scrollTop;
  // console.log("滚动距离" + scrollTop); 
  if (scrollTop > 100) {
    $('#headerMenu').addClass('fixed');
  } else {
    $('#headerMenu').removeClass('fixed');
  }
  if (scrollTop > 200) {
    $('#headerMenu').addClass('fixed2');
  } else {
    $('#headerMenu').removeClass('fixed2');
  }
}, 100)
// // 导航固定
// $(window).scroll(function () {

// });


// 导航固定
$(window).scroll(function () {
  var scrollTop =
    document.documentElement.scrollTop || document.body.scrollTop;
  // console.log("滚动距离" + scrollTop); 
  if (scrollTop > 100) {
    $('#header2Nav').addClass('fixed');
    $('#headerNotice').addClass('fixed');
  } else {
    $('#header2Nav').removeClass('fixed');
    $('#headerNotice').removeClass('fixed');
  }
});


router.afterEach((to, from, next) => {
  if (from.name == 'coursePlay') {} else {
    document.querySelector("body").setAttribute("style", "overflow: auto !important;")
  }
});

new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js